import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { GeneralService } from 'src/app/services/general.service';
import { CustomerService } from 'src/app/services/customer.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { Router } from '@angular/router';
import { MapInformationService } from 'src/app/services/map-information.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-new-customer',
  templateUrl: './new-customer.component.html',
  styleUrls: ['./new-customer.component.scss']
})

export class NewCustomerComponent implements OnInit {
  data: Item[];
  optionsSalesPerson: Item[];
  contrySelect: Item[];
  optionsType: Item[];
  optionsRegion: Array<any>;
  optionsTax: any[] = []

  @Input() VieneDe:any
  @Input() MarkAsConsulting:any
  @Output() result = new EventEmitter();
  @Output() cloeModal = new EventEmitter();

  constructor(
    private customerService: CustomerService,
    private generalService: GeneralService,
    private toast: ToastService,
    private router: Router,
    public fb: FormBuilder,
    public MapInformationService:MapInformationService,
    private translate:TranslateService
  ) {
    this.getCountry();

  }
  public _formEntity: FormGroup;

  ngOnInit() {
    this.initForm();
    this.getTypePerson();
    this.getTypeCustumer();
    this.getCustomerSalesRegion();
  }
  nameTypeCustomer:any=""
  disabledType:boolean = false
  initForm() {

    this._formEntity = new FormGroup({
      customername: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(45)]),
      customernumber: new FormControl({ value: '', disabled: false }, []),
      customertypeid: new FormControl({ value: 0, disabled: false }, [Validators.required]),
      offphone: new FormControl({ value: '', disabled: false }, []),
      phone2: new FormControl({ value: '', disabled: false }, []),
      website: new FormControl({ value: '', disabled: false }, []),
      offfax: new FormControl({ value: '', disabled: false }, []),
      emailaddress: new FormControl({ value: '', disabled: false }, []),
      address: new FormControl({ value: '', disabled: false }, []),
      addressline2: new FormControl({ value: '', disabled: false }, []),
      city: new FormControl({ value: '', disabled: false }, []),
      employeeid: new FormControl({ value: 1, disabled: false }, []),
      zip: new FormControl({ value: '', disabled: false }, []),
      state: new FormControl({ value: '', disabled: false }, []),
      country: new FormControl({ value: '', disabled: false }, []),
      billing: new FormControl({ value: 0, disabled: false }, []),
      customernotes: new FormControl({ value: '', disabled: false }, []),
      billingname: new FormControl({ value: '', disabled: false }, []),
      billingaddress: new FormControl({ value: '', disabled: false }, []),
      billingcity: new FormControl({ value: '', disabled: false }, []),
      billingzip: new FormControl({ value: '', disabled: false }, []),
      billingstate: new FormControl({ value: '', disabled: false }, []),
      billingcountry: new FormControl({ value: '', disabled: false }, []),
      othersalespersonids: new FormControl({ value: null, disabled: false }, []),
      salesregionid: new FormControl({ value: 0, disabled: false }, []),
      hascredit: new FormControl({ value: 1, disabled: false }, []),
      salestaxid: new FormControl({ value: 0, disabled: false }, [Validators.required]),
      date: new FormControl({ value: '', disabled: true }, []),
      createby: new FormControl({ value: '', disabled: true }, []),
      id: new FormControl({ value: 0, disabled: true }, []),
    });

    if(this.VieneDe == 'Consulting'){
      this.MapInformationService.SaveInfoSites({method:"Get_DefaultConsultingfirm"})
        .subscribe(resp=>{
          console.log(resp)
          this._formEntity.get("customertypeid").setValue(resp[0].ID)
          this.nameTypeCustomer = resp[0].CUSTOMERTYPE
          // this.disabledType = true
        })
    } else {
      // this.disabledType = false
    }
  }

  changeCustomerType(event){
    console.log(event)
  }

  getCustomerSalesRegion(){
    this.customerService.GetCustomerSalesRegion().subscribe(
      data => {
        this.optionsRegion = data.map((val) => {
          return {
            label: val.SALESREGION,
            value: val.ID
          };
        });
        
      }
    );

    this.MapInformationService.SaveInfoSites({ method: 'Get_Taxs' }).subscribe(
      data => {
        this.optionsTax = data.map((val) => {
          if (val.TAX != undefined)
            return { 
              label: val.TAX,
              value: val.ID
            };
        });
      }
    );
  }

  submitForm(closemodal, goedit) {
    let formValue;


    formValue = this._formEntity.value;

    this.MapInformationService.SaveInfoSites({method:"Get_DefaultConsultingfirm"})
    .subscribe(resp=>{
      console.log(resp)
      // if(this.VieneDe == 'Consulting'){
      //   this._formEntity.get("customertypeid").setValue(resp[0].ID)
      //   this.nameTypeCustomer = resp[0].CUSTOMERTYPE
      //   formValue.customertypeid = resp[0].ID
      //   this.disabledType = true
      // } else {
      //   this.disabledType = false
      // }

      if (formValue.billing === false || formValue.billing === null) {
        // delete formValue.billingAddress
        formValue = { customeraddresssame: 'false', ...formValue };
        formValue.billing = 0;
      } else {
        //  Error: El servicio no esta guardandolos campos a continuacion
        formValue.billingaddress = formValue.address;
        formValue.billingcity = formValue.city;
        formValue.billingzip = formValue.zip;
        formValue.billingstate = formValue.state;
        formValue.billingcountry = formValue.country;
        // Se implementa el siguiente campo customeraddresssame
        formValue = { customeraddresssame: 'true', ...formValue };
        formValue.billing = 1;
      }
      formValue.hascredit = formValue.hascredit ? 1 : 0;
      
      formValue.method = "Insert_Customer"
      formValue.id = 0
      console.log('formValue', formValue);
      this.MapInformationService.SaveInfoSites(formValue).subscribe(
      // this.generalService.postInsertUpdategeneral('Customer/InsertCustomer', null, formValue).subscribe(
        data => {
          console.log(data);
          this.toast.success(this.translate.instant('msgCustCreSucc'));
          let reesultsite: any;
          reesultsite = { id: data[0].Column1, name: formValue.customername };
          this.result.emit(reesultsite);

          if (closemodal) {
            this.closeModalOutput();
          }

          if(goedit) {
            this.router.navigateByUrl(`/customers/editCustomer/${reesultsite.id}`);
            this.closeModalOutput();
            return;
          }

          this.initForm();
        },
        err => {
          console.log(err)
        }
      )
    })
  }

  getTypePerson() {
    this.generalService.GetSalesPerson().subscribe(
      data => {
        this.optionsSalesPerson = data.map((val) => {
          console.log('getTypePerson', val.value)
          return { // Return the new object structure
            Name: val.CONTACTNAME,
            ID: val.ID
          };
        });
      },
      err => {

      }
    )
  }
  getCountry() {
    this.customerService.GetCountries().subscribe(result => {
      this.contrySelect = result.map((val) => {
        return { // Return the new object structure
          Name: val.COUNTYNAME,
          ID: val.CountryISO3
        };
      });
      console.log('');
    });
  }
  getTypeCustumer() {

    this.generalService.getPopulateGeneral('CustomerType').subscribe(result => {
      if(this.VieneDe != 'Consulting'){
        this.optionsType = result.map((val) => {
          return { // Return the new object structure
            Name: val.CUSTOMERTYPE,
            ID: val.ID

          };
        });
      } else {
        this.optionsType = this.MarkAsConsulting.map((val) => {
          return { // Return the new object structure
            Name: val.CUSTOMERTYPE,
            ID: val.ID
          };
        });
      }
    });
  }

  getSalesperson() {
    this.generalService.GetSalesPerson().subscribe(
      data => {
        this.optionsSalesPerson = data.map((val) => {
          console.log('getTypePerson', val.value)
          return { // Return the new object structure
            Name: val.CONTACTNAME,
            ID: val.ID
          };
        });
      },
      err => {

      }
    )
  }
  closeModalOutput() {
    this.initForm();
    this.cloeModal.emit(true);

  }
  houseNumber:any=""
  street:any=""
  mapCity:any=""
  mapState:any=""
  mapcountry:any=""
  mapPaostalCode:any=""

  handleAddressChange(event) {
    console.log(event.address_components)
    console.log(event)
    for (let i = 1; i < event.address_components.length; i++) {
      let test = event.address_components[i];
      console.log(test)
      if (test.long_name != '') {
        if (test.types[0] == "street_number") {
          this.houseNumber = test.long_name;
        }
        if (test.types[0] == "route") {
          this.street = test.long_name;
        }
        if (test.types[0] == "locality") {
          this.mapCity = test.long_name;
        }
        if (test.types[0] == "administrative_area_level_1") {
          this.mapState = test.short_name;
          // this.mapState = test.long_name;
        }
        if (test.types[0] == "country") {
          this.mapcountry = test.long_name;
        }
        if (test.types[0] == "postal_code") {
          this.mapPaostalCode = test.long_name;
        }
        let streets = this.street && this.houseNumber ? (this.houseNumber + ', ' + this.street) : '';
        test = streets ? streets : this.street;
      }
    }
    this._formEntity.get('address').setValue(event.formatted_address)
    this._formEntity.get('city').setValue(this.mapCity)
    this._formEntity.get('zip').setValue(this.mapPaostalCode)
    this._formEntity.get('country').setValue(this.mapcountry)
    this._formEntity.get('state').setValue(this.mapState)
  }



}

export class Item {
  ID: number;
  Name: string;
}
